/* Affy — GA4 e-commerce events on the GTM dataLayer.
 *
 * The CRO audit found GTM installed but no e-commerce signal: no view_item, add_to_cart or
 * begin_checkout, so GA4/Meta were optimising against page views only. This pushes the standard
 * GA4 events with value + currency. `purchase` deliberately is NOT pushed here — it belongs to
 * Shopify's own checkout/Customer Events pixel, and duplicating it would double-count revenue.
 *
 * Turned on/off by Theme settings → Business & SEO → "Push GA4 e-commerce events".
 * cart.js emits the affy:cart:* events this listens for.
 */
(function () {
  'use strict';
  var T = window.theme || {};
  if (!T.ga4) return;

  var CURRENCY = T.currency || 'AED';
  window.dataLayer = window.dataLayer || [];

  function push(payload) { try { window.dataLayer.push(payload); } catch (e) {} }
  function money(cents) { return Math.round(cents || 0) / 100; }

  /* A Shopify line item (cart.js / cart.json) → a GA4 item. */
  function toItem(line, index) {
    var item = {
      item_id: String(line.product_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      price: money(line.final_price != null ? line.final_price : line.price),
      quantity: line.quantity || 1
    };
    if (line.variant_title) item.item_variant = line.variant_title;
    if (line.product_type) item.item_category = line.product_type;
    if (typeof index === 'number') item.index = index;
    return item;
  }
  function cartItems(cart) {
    return ((cart && cart.items) || []).map(function (line, i) { return toItem(line, i); });
  }
  function sumValue(items) {
    return Math.round(items.reduce(function (t, i) { return t + (i.price * i.quantity); }, 0) * 100) / 100;
  }

  /* ---- view_item (product page) ---- */
  function viewItem() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return;
    var p;
    try { p = JSON.parse(el.textContent); } catch (e) { return; }
    if (!p || !p.id) return;
    var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0] || {};
    var item = {
      item_id: String(p.id),
      item_name: p.title || '',
      price: money(variant.price != null ? variant.price : p.price),
      quantity: 1
    };
    if (variant.title && variant.title !== 'Default Title') item.item_variant = variant.title;
    if (p.type) item.item_category = p.type;
    push({ event: 'view_item', currency: CURRENCY, value: item.price, items: [item] });
  }

  /* ---- add_to_cart ---- */
  document.addEventListener('affy:cart:added', function (e) {
    var res = e.detail || {};
    var lines = res.items && res.items.length ? res.items : (res.id ? [res] : []);
    if (!lines.length) return;
    var items = lines.map(function (l, i) { return toItem(l, i); });
    push({ event: 'add_to_cart', currency: CURRENCY, value: sumValue(items), items: items });
  });

  /* ---- view_cart (drawer opened) ---- */
  var lastCart = null;
  document.addEventListener('affy:cart:updated', function (e) { lastCart = e.detail || null; });
  document.addEventListener('affy:cart:open', function () {
    if (!lastCart || !lastCart.item_count) return;
    var items = cartItems(lastCart);
    push({ event: 'view_cart', currency: CURRENCY, value: money(lastCart.total_price), items: items });
  });

  /* ---- begin_checkout ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"], .cart-checkout');
    if (!btn || !lastCart || !lastCart.item_count) return;
    push({ event: 'begin_checkout', currency: CURRENCY, value: money(lastCart.total_price), items: cartItems(lastCart) });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', viewItem);
  else viewItem();
})();
